export enum SignUpFormType {
  CreateAccount = "OnboardingSignUp",
  EmailVerification = "OnboardingEmailVerification",
  PhoneVerification = "OnboardingSMSVerification",
  VerificationStatus = "OnboardingStatus",
  AccountCreated = "OnboardingAccountCreated",
}
